<template>
  <div v-if="type">
    <DataInput
      type="model"
      name="vacancyTextTemplate"
      :gql-query="query"
      :reduce="el => el"
      :label="label"
      @input="onSelect"
    />
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";
import applicantPlaceholders from "@/data/mailer/applicant";

export default {
  components: {
    DataInput
  },
  props: {
    type: { type: String, default: null },
    label: { type: String, default: null },
    data: { type: Object, default: () => ({}) }
  },
  computed: {
    query() {
      return gql`
        query DocumentPresets($search: String) {
          documentPresets(page: 1, search: $search, type: ${this.type}) {
            results {
              id
              name
              subject
              content
            }
            total
          }
        }
      `;
    }
  },
  methods: {
    onSelect(v) {
      this.$emit("textChoosen", this.replacePlaceholders(v));
    },
    replacePlaceholders(v) {
      for (const placeholder of Object.keys(applicantPlaceholders)) {
        try {
          v.content = v.content.replaceAll(
            `{${placeholder}}`,
            applicantPlaceholders[placeholder](this.data)
          );
        } catch (e) {
          console.log(e);
        }
      }

      return v;
    }
  }
};
</script>
